import { createLocale } from '../../utils.js';

import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';

export default {
  en: createLocale(en, 'webhooks'),
  uk: createLocale(uk, 'webhooks'),
  pl: createLocale(pl, 'webhooks'),
  ru: createLocale(ru, 'webhooks'),
  es: createLocale(es, 'webhooks'),
  uz: createLocale(uz, 'webhooks'),
  hi: createLocale(hi, 'webhooks'),
};
